export default __webpack_public_path__ + "static/img8h-a3acb5d0b681eb978ed0c72ea7d4dffc.jpg";